module.exports = __webpack_public_path__ + "img/loading.086eb908.gif";